/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'badoo': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" _fill="#f88400" d="M0 0h32v32H0V0z"/><path pid="1" _fill="#fff" d="M16 8.642a9.38 9.38 0 00-6.579 2.689V5.602a1.416 1.416 0 00-2.832 0v12.45c0 5.189 4.222 9.411 9.411 9.411s9.411-4.222 9.411-9.411S21.189 8.641 16 8.641zm0 15.989c-3.628 0-6.579-2.951-6.579-6.579s2.951-6.579 6.579-6.579 6.579 2.951 6.579 6.579-2.951 6.579-6.579 6.579z"/><path pid="2" _fill="#fff" d="M14.418 18.011a1.874 1.874 0 11-3.748 0 1.874 1.874 0 013.748 0z"/>'
  }
})
